exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/**\nEssential imports for the global theme, but also to be used in single components\n**/\n.brand-bar__logo {\n  width: 50px;\n}\n@media only screen and (max-width: 767px) {\n.brand-bar__logo {\n    max-height: 50px;\n    object-fit: contain;\n}\n}\n.brand-bar__logo.brand-bar__logo--skeleton {\n  height: 50px;\n  background: #edeef0;\n}\n.brand-bar__title,\n.brand-bar__subtitle {\n  width: 250px;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n.brand-bar__subtitle {\n  font-size: 14px;\n}\n.skeleton {\n  background: #edeef0;\n}", ""]);

// exports
